import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    lineHeight: "32px",
    width: "100%",
  },
  absolute: {
    position: "absolute",
    top: 0,
    left: 0,

    "& $badge": {
      marginLeft: 5,
    },
  },
  badge: {
    float: "left",

    fontSize: "11px!Important",
    fontWeight: 700,
    lineHeight: "22px",
    border: "1px solid",
    width: 22,
    height: 22,
    margin: "5px 5px 5px 0",
    position: "absolute",
    top: "0px",
  },
  label: {
    position: "absolute",
    top: "0px",
    left: "38px",
    maxWidth: "40%",
  },
}));

export default useStyles;
